module.exports = __webpack_public_path__ + "static/media/ibm_logo.8f4e3cc2.svg";